module.exports = __webpack_public_path__ + "static/media/TheoreticalCSLogo.26ec4515.png";